import { computed, unref, type MaybeRef } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { isArturoFlagEnabled } from '@/composables/useSession'
import { hasAccountRole } from '@/utils/roleUtils'
import { getOnboardingStatus } from '@/modules/hub/api'
import { onboardingKeys } from './keys'

interface UseOnboardingStatusQueryOptions {
  enabled?: MaybeRef<boolean>
}

export const useOnboardingStatusQuery = (options: UseOnboardingStatusQueryOptions = {}) => {
  const enabled = computed(
    () => hasAccountRole('ADMIN') && isArturoFlagEnabled('zqa_qa_hub') && unref(options.enabled ?? true),
  )

  return useQuery({
    queryKey: onboardingKeys.status(),
    queryFn: () => getOnboardingStatus(),
    enabled,
    staleTime: Infinity,
    retry: false,
  })
}
